import { Box, Chip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CloseIcon } from "yet-another-react-lightbox";
import { filterEntities, newFilterEntities } from "../../apis/apiService";
import { toast } from "react-toastify";

const formatDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return date.toLocaleDateString();
};

export const FilterSummaryBox = ({
  onApply,
  status_type,
  filter_path,
  task_filter_id,
  has_view_type,
}) => {
  const [filters, setFilters] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const serverityOptions = useSelector(
    (state) => state.selectOptions.SeverityNameOptions
  );
  const activestatus = useSelector(
    (state) => state.selectOptions.StatusOptions
  );

  const activityStatus = activestatus.find(
    (status) => status.status_type === status_type
  );

  const ownerNames = useSelector(
    (state) => state.selectOptions?.ownerNameOptions
  );
  
  // ---- new code ----
  const usersInProjects = useSelector(
    (state) => state.selectOptions?.userNamesByProjects
  );

  const statusList = activityStatus?.status_details.map((status) => ({
    id: status.status_id,
    status_name: status.status_name,
    status_colour: status.status_colour,
  }));

  const isFilterApplied = sessionStorage.getItem("isFilterApplied");
  const isTaskFilterApplied = sessionStorage.getItem("isTaskFilterApplied");
  const isMilestoneFilterApplied = sessionStorage.getItem(
    "isMilestoneFilterApplied"
  );
  const isIssuseFilterApplied = sessionStorage.getItem("isIssueFilterApplied");
  // const isTIFilterApplied = sessionStorage.getItem("isIssueFilterApplied");

  useEffect(() => {
    // if (isFilterApplied === "true") {
        setFilters(null);
    if (status_type === "PROJECT" && isFilterApplied === "true") {
      const sessionData = sessionStorage.getItem("filtered_data");
      if (sessionData) {
        setFilters(JSON.parse(sessionData));
      }
    // }
    // if (isTaskFilterApplied === "true") {
    } else if (status_type === "TASK" && isTaskFilterApplied === "true") {
      const sessionData = sessionStorage.getItem("task_filter_data");
      if (sessionData) {
        setFilters(JSON.parse(sessionData));
      }
    // }
    // if (isMilestoneFilterApplied === "true") {
    } else if (status_type === "MILESTONE" && isMilestoneFilterApplied === "true") {
      const sessionData = sessionStorage.getItem("milestone_filter_data");
      if (sessionData) {
        setFilters(JSON.parse(sessionData));
      }
    // }
    // if (isIssuseFilterApplied === "true") {
    } else if (status_type === "ISSUE" && isIssuseFilterApplied === "true") {
      const sessionData = sessionStorage.getItem("issue_filter_data");
      if (sessionData) {
        setFilters(JSON.parse(sessionData));
      }
    }
  }, [
    status_type,
    isFilterApplied,
    isTaskFilterApplied,
    isMilestoneFilterApplied,
    isIssuseFilterApplied,
    // task_filter_id,
    onApply,
  ]);

  const getUserName = (id) => {
    // ---- old code ----  this code for select owner filter in task tab to shwo owner name not id
    // const user = ownerNames?.find((user) => user.user_id === id);
    // ---- new code ----
        if (!id) return id;
    if (Array.isArray(id)) {
      return id.map(val => {
        let user = ownerNames?.find((user) => String(user.user_id) === String(val));
        if (!user) {
          user = usersInProjects?.find((user) => String(user.user_id) === String(val));
        }
        return user ? user.name : val;
      });
    }
    let user = ownerNames?.find((user) => String(user.user_id) === String(id));
    if (!user) {
      user = usersInProjects?.find((user) => String(user.user_id) === String(id));
    }
    return user ? user.name : id;
  };

  const getStatusName = (id) => {
    // ---- old code ----
    // const status = statusList?.find((status) => status.id === id);
    // ---- new code ----
        if (!id) return id;
    if (Array.isArray(id)) {
      return id.map(val => {
        const status = statusList?.find((status) => String(status.id) === String(val));
        return status ? status.status_name : val;
      });
    }
    const status = statusList?.find((status) => String(status.id) === String(id));
    return status ? status.status_name : id;
  };

  const getSeverityName = (id) => {
    // ---- old code ----
    // const status = serverityOptions?.find(
    //   (status) => status.severity_id === id
    // );
    // ---- new code ----
        if (!id) return id;
    if (Array.isArray(id)) {
      return id.map(val => {
        const status = serverityOptions?.find((status) => String(status.severity_id) === String(val));
        return status ? status.severity_name : val;
      });
    }
    const status = serverityOptions?.find((status) => String(status.severity_id) === String(id));
    return status ? status.severity_name : id;
  };

  const labelMap = {
    Title: "title",
    Owner: "project_manager_id",
    "Start Date": "start_date",
    "End Date": "end_date",
    "Billing Type": "billing_type",
    "Added By": "added_by",
    Status: "current_status_id",
    "Created Date": "added_at",
    "Last Modified By": "updated_by",
  };
  const TaskLabelMap = {
    Title: "title",
    Owner: "owner",
    "Start Date": "start_date",
    "End Date": "end_date",
    "Billing Type": "billing_type",
    "Added By": "added_by",
    Status: "current_status_id",
    "Created Date": "added_at",
    "Last Modified By": "updated_by",
  };
  const milestoneLabelMap = {
    Title: "name",
    Owner: "owner_id",
    "Start Date": "start_date",
    "End Date": "end_date",
    Status: "current_status_id",
  };
  const issueLabelMap = {
    Title: "title",
    Assignee: "assignee",
    "Start Date": "start_due_date",
    "End Date": "end_due_date",
    "Reporter ": "billing_type",
    "Added By": "added_by",
    Status: "current_status_id",
    "Created Date": "created_date",
    "Created By": "added_by",
    "Last Modified By": "last_modified_by",
    Severity: "severity_id",
  };
  // console.log("filter value :", filters);

  const entries = [
    { label: "Title", value: filters?.title },
    { label: "Owner", value: getUserName(filters?.project_manager_id) },
    { label: "Start Date", value: formatDate(filters?.start_date) },
    { label: "End Date", value: formatDate(filters?.end_date) },
    { label: "Billing Type", value: filters?.billing_type },
    { label: "Added By", value: getUserName(filters?.added_by) },
    { label: "Status", value: getStatusName(filters?.current_status_id) },
    { label: "Created Date", value: formatDate(filters?.added_at) },
    { label: "Last Modified By", value: getUserName(filters?.updated_by) },
  ];
  const taskEntries = [
    { label: "Title", value: filters?.title },
    { label: "Owner", value: getUserName(filters?.owner) },
    { label: "Start Date", value: formatDate(filters?.start_date) },
    { label: "End Date", value: formatDate(filters?.end_date) },
    { label: "Billing Type", value: filters?.billing_type },
    { label: "Added By", value: getUserName(filters?.added_by) },
    { label: "Status", value: getStatusName(filters?.current_status_id) },
    { label: "Created Date", value: formatDate(filters?.added_at) },
    { label: "Last Modified By", value: getUserName(filters?.updated_by) },
  ];
  const milestoneEntries = [
    { label: "Title", value: filters?.title },
    { label: "Owner", value: getUserName(filters?.owner_id) },
    { label: "Start Date", value: formatDate(filters?.start_date) },
    { label: "End Date", value: formatDate(filters?.end_date) },
    { label: "Billing Type", value: filters?.billing_type },
    // { label: "Added By", value: getUserName(filters?.added_by) },
    { label: "Status", value: getStatusName(filters?.current_status_id) },
    // { label: "Created Date", value: formatDate(filters?.added_at) },
    // { label: "Last Modified By", value: getUserName(filters?.updated_by) },
  ];
  const issueEntries = [
    { label: "Title", value: filters?.title },
    { label: "Assignee", value: getUserName(filters?.assignee) },
    { label: "Start Date", value: formatDate(filters?.start_due_date) },
    { label: "End Date", value: formatDate(filters?.end_due_date) },
    // { label: "Billing Type", value: filters?.billing_type },
    { label: "Reporter", value: getUserName(filters?.added_by) },
    { label: "Created By", value: getUserName(filters?.added_by) },
    { label: "Status", value: getStatusName(filters?.current_status_id) },
    { label: "Created Date", value: formatDate(filters?.created_date) },
    {
      label: "Last Modified By",
      value: getUserName(filters?.last_modified_by),
    },
    { label: "Severity", value: getSeverityName(filters?.severity_id) },
  ];
  const buildRequestedData = (filterData) => ({
    title: filterData?.title || null,
    project_manager_id: filterData?.project_manager_id || null,
    start_date: filterData?.start_date || null,
    end_date: filterData?.end_date || null,
    billing_type: filterData?.billing_type || null,
    added_by: filterData?.added_by || null,
    current_status_id: filterData?.current_status_id || null,
    added_at: filterData?.added_at || null,
    updated_by: filterData?.updated_by || null,
  });
  const taskBuildRequestedData = (filterData) => ({
    title: filterData?.title || null,
    owner: filterData?.owner || null,
    start_date: filterData?.start_date || null,
    end_date: filterData?.end_date || null,
    billing_type: filterData?.billing_type || null,
    added_by: filterData?.added_by || null,
    current_status_id: filterData?.current_status_id || null,
    added_at: filterData?.added_at || null,
    updated_by: filterData?.updated_by || null,
    view_type_id: filterData?.view_type_id || 1,
  });
  const milestoneBuildRequestedData = (filterData) => ({
    name: filterData?.name || null,
    // project_manager_id: filterData?.project_manager_id || null,
    start_date: filterData?.start_date || null,
    end_date: filterData?.end_date || null,
    billing_type: filterData?.billing_type || null,
    owner_id: filterData?.owner_id || null,
    current_status_id: filterData?.current_status_id || null,
    // added_at: filterData?.added_at || null,
    // updated_by: filterData?.updated_by || null,
    view_type_id: filterData?.view_type_id || 1,
  });
  const issueBuildRequestedData = (filterData) => ({
    title: filterData?.title || null,
    assignee: filterData?.assignee || null,
    start_due_date: filterData?.start_due_date || null,
    end_due_date: filterData?.end_due_date || null,
    added_by: filterData?.added_by || null,
    // added_by: filterData?.added_by || null,
    current_status_id: filterData?.current_status_id || null,
    created_date: filterData?.created_date || null,
    last_modified_by: filterData?.last_modified_by || null,
    severity_id: filterData?.severity_id || null,
    view_type_id: filterData?.view_type_id || 1,
  });

  const refetchWithUpdatedFilters = async (updatedFilters) => {
    console.log("updatedFilters :", updatedFilters);

    setIsSubmitting(true);
    let requestedData;
    // if (isFilterApplied === "true") {
       if (status_type === "PROJECT") {
      requestedData = buildRequestedData(updatedFilters);
      
    // } else if (isTaskFilterApplied === "true") {
    } else if (status_type === "TASK") {
      requestedData = taskBuildRequestedData(updatedFilters);
      
    // } else if (isMilestoneFilterApplied === "true") {
     } else if (status_type === "MILESTONE") {
      requestedData = milestoneBuildRequestedData(updatedFilters);
      
    // } else if (isIssuseFilterApplied === "true") {
      } else if (status_type === "ISSUE") {
      requestedData = issueBuildRequestedData(updatedFilters);
    }
    
    try {
      let response;
      // if (isFilterApplied === "true") {
      if (status_type === "PROJECT") {
        response = await filterEntities(filter_path, requestedData);
        setFilters(updatedFilters);
        sessionStorage.setItem("filtered_data", JSON.stringify(updatedFilters));

      // } else if (isTaskFilterApplied === "true") {
        } 
        else if (status_type === "TASK") {
        response = await newFilterEntities(
          filter_path,
          task_filter_id,
          requestedData
        );

        setFilters(updatedFilters);
        sessionStorage.setItem(
          "task_filter_data",
          JSON.stringify(updatedFilters)
        );
        
      // } else if (isMilestoneFilterApplied === "true") {
         } 
         else if (status_type === "MILESTONE") {
        response = await newFilterEntities(
          filter_path,
          task_filter_id,
          requestedData
        );

        setFilters(updatedFilters);
        sessionStorage.setItem(
          "milestone_filter_data",
          JSON.stringify(updatedFilters)
        );
        
      // } else if (isIssuseFilterApplied === "true") {
      } 
      else if (status_type === "ISSUE") {
        response = await newFilterEntities(
          filter_path,
          task_filter_id,
          requestedData
        );
        setFilters(updatedFilters);
        sessionStorage.setItem(
          "issue_filter_data",
          JSON.stringify(updatedFilters)
        );
      }

      if (response.data) {
        onApply?.(response.data);
        let msg = response.message;
        if (status_type === "TASK") {
          msg = "Task filter applied successfully!";
        } 
        else if (status_type === "ISSUE") {
          msg = "Issue filter applied successfully!";
        } 
        else if (status_type === "MILESTONE") {
          msg = "Milestone filter applied successfully!";
        } 
        else if (status_type === "PROJECT") {
          msg = "Project filter applied successfully!";
        }
        toast.success(msg);
        } 
        else {
          toast.error(response.message);
      }
    } 
    catch (err) {
      toast.error(err.message || "Failed to fetch projects.");
    } 
    finally {
      setIsSubmitting(false);
    }
  };
  
  const getLabelKey = (label) => {
    // if (isFilterApplied === "true") return labelMap[label];
    // if (isTaskFilterApplied === "true") return TaskLabelMap[label];
    // if (isIssuseFilterApplied === "true") return issueLabelMap[label];
    // if (isMilestoneFilterApplied === "true") return milestoneLabelMap[label];

    if (status_type === "PROJECT") return labelMap[label];
    if (status_type === "TASK") return TaskLabelMap[label];
    if (status_type === "ISSUE") return issueLabelMap[label];
    if (status_type === "MILESTONE") return milestoneLabelMap[label];
    return null;
  };

  const handleDelete = (label, valueToRemove) => {
    const key = getLabelKey(label);
    console.log("Trying to delete", label, "→", key);
    if (!key) return;

    // Count active chips instead of fields
    const activeEntries =
      // isFilterApplied === "true"
       status_type === "PROJECT"
        ? entries
        // : isTaskFilterApplied === "true"
         : status_type === "TASK"
        ? taskEntries
        // : isIssuseFilterApplied === "true"
        : status_type === "ISSUE"
        ? issueEntries
        : milestoneEntries;
    const totalChips = activeEntries.reduce((count, entry) => {
      if (!entry.value) return count;
      return count + (Array.isArray(entry.value) ? entry.value.length : 1);
    }, 0);

    if (has_view_type && totalChips <= 1) {
      toast.error("Please clear all filters instead.");
      return;
    }
    if (!has_view_type && totalChips <= 1) {
      toast.error("Please clear all filters instead.");
      return;
    }

    let updatedFilters = { ...filters };

    // Remove value from array or set null for single-value fields
    const currentValue = filters[key];
    if (Array.isArray(currentValue)) {
      const newArray = currentValue.filter((v) => v !== valueToRemove);
      updatedFilters[key] = newArray.length > 0 ? newArray : null;
    } else {
      updatedFilters[key] = null;
    }

    refetchWithUpdatedFilters(updatedFilters);
  };

  const renderChips = () => {
    const activeEntries =
      // isFilterApplied === "true"
       status_type === "PROJECT"
        ? entries
        // : isTaskFilterApplied === "true"
         : status_type === "TASK"
        ? taskEntries
        // : isIssuseFilterApplied === "true"
        : status_type === "ISSUE"
        ? issueEntries
        : milestoneEntries;
    return activeEntries.flatMap((entry, index) => {
      if (!entry.value) return [];
      const values = Array.isArray(entry.value) ? entry.value : [entry.value];

      return values.map((val, i) => (
        <Chip
          key={`${index}-${i}`}
          label={`${entry.label}: ${val}`}
          onDelete={() => handleDelete(entry.label, val)}
          deleteIcon={<CloseIcon sx={{ color: "red" }} />}
          sx={{
            backgroundColor: "var(--chip-bg-color)",
            color: "var(--chip-text-color)",
            border: "1px solid var(--chip-border-color)",
            ".MuiChip-deleteIcon": { marginLeft: 0.5 },
          }}
        />
      ));
    });
  };

  if (!filters) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1,
        padding: 2,
        border: "1px solid var(--border-color)",
        borderRadius: 2,
        marginBottom: 2,
        backgroundColor: "var(--cell-bg-color)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ width: "100%", fontWeight: "bold", color: "var(--text-color)" }}
      >
        Applied Filters:
      </Typography>
      {renderChips()}
    </Box>
  );
};
